const VERSE_SECTION_RANGE_MIN = 1
const VERSE_SECTION_RANGE_MAX = 9999

const MINIMUM_MEANINGFUL_IDENTIFIER_LENGTH = 3

export {
	VERSE_SECTION_RANGE_MIN,
	VERSE_SECTION_RANGE_MAX,
	MINIMUM_MEANINGFUL_IDENTIFIER_LENGTH,
}
